/** Decimal percentage to integer basis points without floating-point drift. */
export function percentToBps(value: string): number | null {
  const m = /^(\d{1,3})(?:\.(\d{1,2}))?$/.exec(value.trim());
  if (!m) return null;
  const n = Number(m[1]) * 100 + Number((m[2] ?? '').padEnd(2, '0'));
  return n <= 10000 ? n : null;
}
